import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { useBreakpointUp } from '@travel-frontend/core';
import { IconCashBack, IconCreditCard, IconGiftCard, IconPhoneIphone } from '@travel-frontend/icons';
import { useTranslation } from 'next-i18next';
import { Container, Copy, Cost, Info } from '../../components/Voucher/components/index.js';
import { VOUCHER_TYPE_APP, VOUCHER_TYPE_CASHBACK, VOUCHER_TYPE_GIFT } from '../../components/Voucher/models.js';
import { LabelSmall, LabelXSmall, LabelXSmallBold, LabelXxLargeBold, Link, ParagraphXSmall, ParagraphXSmallBold, Stack } from '../../primitives/index.js';
import { priceFormatter } from '../../utils/index.js';
export const Voucher = ({
  type,
  code,
  value,
  currency = 'EUR',
  minBookingPrice,
  status,
  expireDate,
  expired = false,
  conditionsLink = '',
  isAppVoucher = false,
  onCopy,
  ...restProps
}) => {
  const {
    t
  } = useTranslation('voucher');
  const lgUp = useBreakpointUp('lg');
  const getIcon = () => {
    switch (type) {
      case VOUCHER_TYPE_CASHBACK:
        {
          return _jsx(IconCashBack, {
            fontScale: "small"
          });
        }
      case VOUCHER_TYPE_GIFT:
        {
          return _jsx(IconGiftCard, {
            fontScale: "small"
          });
        }
      case VOUCHER_TYPE_APP:
        {
          return _jsx(IconPhoneIphone, {
            fontScale: "small"
          });
        }
      default:
        {
          return _jsx(IconCreditCard, {
            fontScale: "small"
          });
        }
    }
  };
  return _jsxs(Container, {
    direction: "row",
    spacing: "none",
    ...restProps,
    expired: expired,
    children: [_jsxs(Cost, {
      alignItems: "center",
      justifyContent: "center",
      spacing: "small",
      expired: expired,
      children: [_jsx(LabelXxLargeBold, {
        color: expired ? 'contentTertiary' : 'interactionSecondary',
        truncate: true,
        children: priceFormatter('de-DE', currency, 0).format(value)
      }), _jsx(LabelXSmall, {
        textAlign: "center",
        color: expired ? 'contentTertiary' : 'contentSecondary',
        children: t(`expireUntil`, {
          date: expireDate
        })
      })]
    }), _jsxs(Info, {
      spacing: "xSmall",
      justifyContent: "center",
      expired: expired,
      children: [_jsxs(Stack, {
        direction: "row",
        alignItems: "center",
        spacing: "xSmall",
        children: [getIcon(), _jsx(LabelXSmallBold, {
          truncate: true,
          children: t(`voucherType`, {
            context: type
          })
        })]
      }), _jsx(Stack, {
        direction: "row",
        spacing: "large",
        alignItems: "center",
        justifyContent: "space-between",
        children: _jsx(LabelSmall, {
          truncate: true,
          color: "contentSecondary",
          children: code
        })
      }), expired ? _jsx(LabelXSmall, {
        color: "contentTertiary",
        children: t(`notValid`, {
          context: status
        })
      }) : _jsxs(Stack, {
        spacing: "none",
        children: [isAppVoucher && _jsx(ParagraphXSmallBold, {
          children: t('onlyApp')
        }), _jsx(ParagraphXSmall, {
          color: "contentSecondary",
          truncate: 2,
          children: t(`minPrice`, {
            value: priceFormatter('de-DE', currency, 0).format(minBookingPrice)
          })
        }), _jsx(ParagraphXSmall, {
          color: "contentSecondary",
          children: _jsx(Link, {
            href: conditionsLink,
            target: "_blank",
            children: t('moreLink')
          })
        })]
      })]
    }), _jsx(Copy, {
      hidden: expired || isAppVoucher && lgUp,
      code: code,
      onCopy: onCopy
    })]
  });
};